import appStore from 'store';
import api from './api';
import {
  REGISTER_FORM,
  USER_STATUS,
  BANK_AUTH_STATUS,
  ID_NO_STATUS,
  EMAIL_SECURITY_STATUS,
  PHONE_SECURITY_STATUS,
  GOOGLE_SECURITY_STATUS,
  USER_VALUNTEER_STATUS,
  USER_BLOCKING_STATUS,
  QUERY_TYPE,
  PAGINATION
} from './constants';

const store = {
  namespaced: true,
  state: {
    userList: [],
    totalCount: 0,
    pagination: PAGINATION,
    queryTypeList: QUERY_TYPE,
    queryType: QUERY_TYPE[0].value,
    userinfoDetail: {},
    userinfoDetailDialogVisible: false,
    dialogVisible: false,
    notedetail: {},
    countryCodeList: [],
    blockHeightTaskList:[],
    countDataList:[]
  },
  getters: {
    userList: state =>
      state.userList.map(item => {
        return {
          ...item,
          __registerFrom: REGISTER_FORM[item.registerFrom],
          __userStatus: USER_STATUS[item.userStatus],
          __bankAuthStatus: BANK_AUTH_STATUS[item.bankAuthStatus],
          __idNoStatus: ID_NO_STATUS[item.idNoStatus || 0],
          __emailSecurityStatus:
            EMAIL_SECURITY_STATUS[item.emailSecurityStatus || 0],
          __phoneSecurityStatus:
            PHONE_SECURITY_STATUS[item.phoneSecurityStatus || 0],
          __googleSecurityStatus:
            GOOGLE_SECURITY_STATUS[item.googleSecurityStatus || 0],
          __userVolunteerStatus:
            USER_VALUNTEER_STATUS[item.userVolunteerStatus || 0],
          __userBlockingStatus: USER_BLOCKING_STATUS[item.userStatus || 0]
        };
      })
  },
  mutations: {
    setHeightTaskList(state, payload) {
      state.blockHeightTaskList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    setUserinfoDetailDialogVisible(state,payload){
      state.userinfoDetailDialogVisible=payload
    },
    setUserinfoDetail(state,payload){
      state.userinfoDetail=payload
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setCountDataList(state, payload) {
      state.countDataList = payload;
    }
  },
  actions: {
   
    delOne({commit},id){
    return  api.delOne(id).then(res=>{
        return res
      })
    },
    updatInfo({commit},blockInfoDto){
      return api.updatInfo(blockInfoDto).then(res=>{
        return res
      })
    },
    getBlockHeightTask({commit},data){
      api.getBlockHeightTask(data).then(res=>{
        commit('setHeightTaskList',res.data)
      })
    },
    getCountData({commit}){
      api.getCountData().then(res=>{
        console.log('getCountData-res',res);
        commit('setCountDataList',res.data)
      })
    }
  }
};

appStore.registerModule('blockHeightTask', store);
